export const BACKEND_REDIRECTION_REQUEST = "BACKEND_REDIRECTION_REQUEST";
export const BACKEND_REDIRECTION_SUCCESS = "BACKEND_REDIRECTION_SUCCESS";
export const BACKEND_REDIRECTION_FAIL = "BACKEND_REDIRECTION_FAIL";

export const GET_INCIDENTS_REQUEST = "GET_INCIDENTS_REQUEST";
export const GET_INCIDENTS_SUCCESS = "GET_INCIDENTS_SUCCESS";
export const GET_INCIDENTS_FAIL = "GET_INCIDENTS_FAIL";

export const GET_INCIDENT_DETAILS_REQUEST = "GET_INCIDENT_DETAILS_REQUEST";
export const GET_INCIDENT_DETAILS_SUCCESS = "GET_INCIDENT_DETAILS_SUCCESS";
export const GET_INCIDENT_DETAILS_FAIL = "GET_INCIDENT_DETAILS_FAIL";

export const GET_FILTER_LOOKUP_REQUEST = "GET_FILTER_LOOKUP_REQUEST";
export const GET_FILTER_LOOKUP_SUCCESS = "GET_FILTER_LOOKUP_SUCCESS";
export const GET_FILTER_LOOKUP_FAIL = "GET_FILTER_LOOKUP_SUCCESS_FAIL";

export const GET_SUMMARY_REQUEST = "GET_SUMMARY_REQUEST";
export const GET_SUMMARY_SUCCESS = "GET_SUMMARY_SUCCESS";
export const GET_SUMMARY_FAIL = "GET_SUMMARY_SUCCESS_FAIL";

export const GET_DETECTION_QUALITY_SUMMARY_REQUEST = "GET_DETECTION_QUALITY_SUMMARY_REQUEST";
export const GET_DETECTION_QUALITY_SUMMARY_SUCCESS = "GET_DETECTION_QUALITY_SUMMARY_SUCCESS";
export const GET_DETECTION_QUALITY_SUMMARY_FAIL = "GET_DETECTION_QUALITY_SUMMARY_SUCCESS_FAIL";

export const GET_DETECTION_QUALITY_INCIDENTS_REQUEST = "GET_DETECTION_QUALITY_INCIDENTS_REQUEST";
export const GET_DETECTION_QUALITY_INCIDENTS_SUCCESS = "GET_DETECTION_QUALITY_INCIDENTS_SUCCESS";
export const GET_DETECTION_QUALITY_INCIDENTS_FAIL = "GET_DETECTION_QUALITY_INCIDENTS_FAIL";

export const GET_DETECTION_QUALITY_INCIDENT_DETAILS_REQUEST = "GET_DETECTION_QUALITY_INCIDENT_DETAILS_REQUEST";
export const GET_DETECTION_QUALITY_INCIDENT_DETAILS_SUCCESS = "GET_DETECTION_QUALITY_INCIDENT_DETAILS_SUCCESS";
export const GET_DETECTION_QUALITY_INCIDENT_DETAILS_FAIL = "GET_DETECTION_QUALITY_INCIDENT_DETAILS_FAIL";

export const GET_DETECTION_QUALITY_FILTER_LOOKUP_REQUEST = "GET_DETECTION_QUALITY_FILTER_LOOKUP_REQUEST";
export const GET_DETECTION_QUALITY_FILTER_LOOKUP_SUCCESS = "GET_DETECTION_QUALITY_FILTER_LOOKUP_SUCCESS";
export const GET_DETECTION_QUALITY_FILTER_LOOKUP_FAIL = "GET_DETECTION_QUALITY_FILTER_LOOKUP_SUCCESS_FAIL";

export const GET_LAST_REFRESH_DATE_REQUEST = "GET_LAST_REFRESH_DATE_REQUEST";
export const GET_LAST_REFRESH_DATE_SUCCESS = "GET_LAST_REFRESH_DATE_SUCCESS";
export const GET_LAST_REFRESH_DATE_FAIL = "GET_LAST_REFRESH_DATE_SUCCESS_FAIL";

export const GET_MUNICIPALITY_AND_STREET_DATA_REQUEST = "GET_MUNICIPALITY_AND_STREET_DATA_REQUEST";
export const GET_MUNICIPALITY_AND_STREET_DATA_SUCCESS = "GET_MUNICIPALITY_AND_STREET_DATA_SUCCESS";
export const GET_MUNICIPALITY_AND_STREET_DATA_FAIL = "GET_MUNICIPALITY_AND_STREET_DATA_FAIL";

export const GET_MUNICIPALITY_AND_STREET_DATA_SMART_SUPERVISION_REQUEST = "GET_MUNICIPALITY_AND_STREET_DATA_SMART_SUPERVISION_REQUEST";
export const GET_MUNICIPALITY_AND_STREET_DATA_SMART_SUPERVISION_SUCCESS = "GET_MUNICIPALITY_AND_STREET_DATA_SMART_SUPERVISION_SUCCESS";
export const GET_MUNICIPALITY_AND_STREET_DATA_SMART_SUPERVISION_FAIL = "GET_MUNICIPALITY_AND_STREET_DATA_SMART_SUPERVISION_FAIL";

export const GET_SMART_SUPERVISION_SUMMARY_REQUEST = "GET_SMART_SUPERVISION_SUMMARY_REQUEST";
export const GET_SMART_SUPERVISION_SUMMARY_SUCCESS = "GET_SMART_SUPERVISION_SUMMARY_SUCCESS";
export const GET_SMART_SUPERVISION_SUMMARY_FAIL = "GET_SMART_SUPERVISION_SUMMARY_SUCCESS_FAIL";

export const GET_COVERAGE_STREET_DATA_REQUEST = "GET_COVERAGE_STREET_DATA_REQUEST";
export const GET_COVERAGE_STREET_DATA_SUCCESS = "GET_COVERAGE_STREET_DATA_SUCCESS";
export const GET_COVERAGE_STREET_DATA_FAIL = "GET_COVERAGE_STREET_DATA_FAIL";

export const GET_HIGHEST_ELEMENTS_DATA_REQUEST = "GET_HIGHEST_ELEMENTS_DATA_REQUEST";
export const GET_HIGHEST_ELEMENTS_DATA_SUCCESS = "GET_HIGHEST_ELEMENTS_DATA_SUCCESS";
export const GET_HIGHEST_ELEMENTS_DATA_FAIL = "GET_HIGHEST_ELEMENTS_DATA_FAIL";

export const GET_VPI_DATA_REQUEST = "GET_VPI_DATA_REQUEST";
export const GET_VPI_DATA_SUCCESS = "GET_VPI_DATA_SUCCESS";
export const GET_VPI_DATA_FAIL = "GET_VPI_DATA_FAIL";

export const GET_VPI_TRENDS_REQUEST = "GET_VPI_TRENDS_REQUEST";
export const GET_VPI_TRENDS_SUCCESS = "GET_VPI_TRENDS_SUCCESS";
export const GET_VPI_TRENDS_FAIL = "GET_VPI_TRENDS_FAIL";

export const TOGGLE_NAV_HIDE = "TOGGLE_NAV_HIDE";

export const GET_STREET_COVERAGE_REQUEST = "GET_STREET_COVERAGE_REQUEST";
export const GET_STREET_COVERAGE_SUCCESS = "GET_STREET_COVERAGE_SUCCESS";
export const GET_STREET_COVERAGE_FAIL = "GET_STREET_COVERAGE_FAIL";

export const GET_ROAD_OPTIONS_REQUEST = "GET_ROAD_OPTIONS_REQUEST";
export const GET_ROAD_OPTIONS_SUCCESS = "GET_ROAD_OPTIONS_SUCCESS";
export const GET_ROAD_OPTIONS_FAIL = "GET_ROAD_OPTIONS_FAIL";

export const GET_COVERAGE_PROGRESS_REQUEST = "GET_COVERAGE_PROGRESS_REQUEST";
export const GET_COVERAGE_PROGRESS_SUCCESS = "GET_COVERAGE_PROGRESS_SUCCESS";
export const GET_COVERAGE_PROGRESS_FAIL = "GET_COVERAGE_PROGRESS_FAIL";

export const GET_USERS_REQUEST = "GET_USERS_REQUEST";
export const GET_USERS_SUCCESS = "GET_USERS_SUCCESS";
export const GET_USERS_FAIL = "GET_USERS_FAIL";

export const GET_DEPARTMENTS_REQUEST = "GET_DEPARTMENTS_REQUEST";
export const GET_DEPARTMENTS_SUCCESS = "GET_DEPARTMENTS_SUCCESS";
export const GET_DEPARTMENTS_FAIL = "GET_DEPARTMENTS_FAIL";

export const GET_DEPARTMENT_DATA_SUMMARY_REQUEST = "GET_DEPARTMENT_DATA_SUMMARY_REQUEST";
export const GET_DEPARTMENT_DATA_SUMMARY_SUCCESS = "GET_DEPARTMENT_DATA_SUMMARY_SUCCESS";
export const GET_DEPARTMENT_DATA_SUMMARY_FAIL = "GET_DEPARTMENT_DATA_SUMMARY_FAIL";

export const GET_RECENT_INCIDENTS_HEATMAP_REQUEST = 'GET_RECENT_INCIDENTS_HEATMAP_REQUEST';
export const GET_RECENT_INCIDENTS_HEATMAP_SUCCESS = 'GET_RECENT_INCIDENTS_HEATMAP_SUCCESS';
export const GET_RECENT_INCIDENTS_HEATMAP_FAIL = 'GET_RECENT_INCIDENTS_HEATMAP_FAIL';

export const GET_RECENT_INCIDENTS_HEATMAP_REQUEST_DETAILS = 'GET_RECENT_INCIDENTS_HEATMAP_REQUEST_DETAILS';
export const GET_RECENT_INCIDENTS_HEATMAP_SUCCESS_DETAILS = 'GET_RECENT_INCIDENTS_HEATMAP_SUCCESS_DETAILS';
export const GET_RECENT_INCIDENTS_HEATMAP_FAIL_DETAILS = 'GET_RECENT_INCIDENTS_HEATMAP_FAIL_DETAILS';

export const GET_HEATMAP_FILTER_LOOKUPS_REQUEST = 'GET_HEATMAP_FILTER_LOOKUPS_REQUEST';
export const GET_HEATMAP_FILTER_LOOKUPS_SUCCESS = 'GET_HEATMAP_FILTER_LOOKUPS_SUCCESS';
export const GET_HEATMAP_FILTER_LOOKUPS_FAILURE = 'GET_HEATMAP_FILTER_LOOKUPS_FAILURE';

export const PAGE_CHANGE = "PAGE_CHANGE";

export const SAVE_USER_REQUEST = "SAVE_USER_REQUEST";
export const SAVE_USER_SUCCESS = "SAVE_USER_SUCCESS";
export const SAVE_USER_FAIL = "SAVE_USER_FAIL";

export const GET_USER_LIST_REQUEST = "GET_USER_LIST_REQUEST";
export const GET_USER_LIST_SUCCESS = "GET_USER_LIST_SUCCESS";
export const GET_USER_LIST_FAIL = "GET_USER_LIST_FAIL";

